import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AdminAiTesterComponent } from './admin-ai-tester.component';

const routes: Routes = [
  {
    path: '',
    component: AdminAiTesterComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AdminAiTesterRoutingModule {}
